"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ponte-buggianese": {
    "47cd1bf8": [{
      "hkey": "bf99ffac",
      "slug": "anchione-ponte-di-mingo",
      "name": "Anchione-Ponte di Mingo",
      "primary": true,
      "skipSearch": false
    }],
    "anchione": [{
      "hkey": "bf99ffac",
      "slug": "anchione-ponte-di-mingo",
      "name": "Anchione-Ponte di Mingo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "58282d1a": [{
      "hkey": "bc9d611f",
      "slug": "ponte-buggianese",
      "name": "Ponte Buggianese",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-a-buggiano": [{
      "hkey": "bc9d611f",
      "slug": "ponte-buggianese",
      "name": "Ponte Buggianese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "948fbcef": [{
      "hkey": "bf99ffac",
      "slug": "anchione-ponte-di-mingo",
      "name": "Anchione-Ponte di Mingo",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-di-mingo": [{
      "hkey": "bf99ffac",
      "slug": "anchione-ponte-di-mingo",
      "name": "Anchione-Ponte di Mingo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ponte-buggianese"
    }]
  }
};
exports["default"] = _default;